import {h, Fragment} from "preact"
import { useProductFilters } from '@nosto/preact';

function FilterRemoveButton({ filter, className }) {
  return (
    <button
      className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
      onClick={() => filter.remove()}
    >
      ×
    </button>
  );
}

export default function SelectedFilters() {
  const { filters, removeAll } = useProductFilters();

  return (
    filters.length > 0 && (
      <div class="ns-d-flex ns-flex-wrap  ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2">
        <div class="ns-d-flex ns-flex-wrap ">
          <span class="active-filters-title">Refine by</span>
          {filters.map((filter) => (
            <div
              class=" active-filter-item ns-clickable"
              onClick={() => filter.remove()}
            >
              <span class="ns-color-black">
                {filter.name}: {filter.value}
              </span>
              {/* <FilterRemoveButton filter={filter} /> */}
            </div>
          ))}
        </div>
        <div class="Clear-all-active ns-pt-1">
          <a
            href="javascript:void(0)"
            class="ns-ml-2 ns-mr-0 "
            onClick={() => {
              removeAll();
            }}
          >
            Clear Filters
          </a>
        </div>
      </div>
    )
  );
}
